import React, { useState, useEffect } from 'react'


const SubRating = ({ ratingData }) => {

    const [link, setLink] = useState(ratingData.link)

    useEffect(() => {
        linkUpdate();
    }, []);

    const linkUpdate = () => {
        if (link.substr(0, 3) !== "http" && link.substr(0, 1) !== "//") {
            setLink("//" + link)
        }
    }

    return (
        <a href={link} target="_blank" rel="noopener noreferrer">
            <div className='md:mx-4 w-52 flex flex-col items-center'>
                <div className='bg-blue-400 h-16 w-16 rounded-full text-center flex justify-center items-center transition duration-150 ease-in-out hover:scale-110'>
                    {/* <img className='w-8 text-white' src={ratingData.review_platform_icon} alt='icon' /> */}
                    <div className='text-white text-4xl'>{ratingData.review_from[0].toUpperCase()}</div>
                </div>
                <div className='mt-2 text-center'>{ratingData.review_star}/5</div>
                <div className=''>({ratingData.total_review} Ratings)</div>
            </div>
        </a>
    )
}

export default SubRating
